import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";
import PageHero from "../../components/public/PageHero";

export default function NoticiasList() {
  const { t, pick, lang } = useLang();
  const [news, setNews] = useState([]);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="noticias-page">
      <PageHero
        title={t("nav.noticias")}
        subtitle={lang === "es" ? "Actualidad e información de nuestros socios" : "Actualités et informations de nos membres"}
      />
      <section className="max-w-7xl mx-auto px-6 py-20">
        {news.length === 0 ? (
          <p className="text-center text-gray-500 py-20">{t("common.noContent")}</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((n) => (
              <article key={n.id} className="bg-white border border-gray-100 group hover:shadow-xl transition-shadow" data-testid={`noticia-${n.slug}`}>
                {n.cover_image && (
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={n.cover_image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                )}
                <div className="p-7">
                  {n.tag && <span className="text-[10px] font-semibold uppercase tracking-widest text-[#C8102E]">{n.tag}</span>}
                  <h3 className="font-serif text-2xl text-[#0F2040] mt-3 mb-3 leading-tight">{pick(n, "title")}</h3>
                  <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-3">{pick(n, "excerpt")}</p>
                  <Link to={`/noticias-socios/${n.slug}`} className="text-sm font-medium text-[#C8102E] hover:text-[#0F2040]">
                    {t("common.readMore")} →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
